import React from 'react';
import { AlertCircle } from '../../../../assets/icons';
import './style.scss';

export default function InfoNoticeBox({ infoPoints, translate, infoTitle }) {
  const highlightWords = (segment, i) => {
    if (segment.strong) {
      return <strong key={i}>{segment.text}</strong>;
    } else if (segment.highlightRed) {
      return (
        <strong
          key={i}
          style={{ color: '#D92D20' }}
        >
          {segment.text}
        </strong>
      );
    } else if (segment.highlightGreen) {
      return (
        <strong
          key={i}
          style={{ color: '#079455' }}
        >
          {segment.text}
        </strong>
      );
    } else {
      return <span key={i}>{segment.text}</span>;
    }
  };

  return (
    <div className='info-notice-wrapper'>
      <div className='info-notice-content'>
        <div className='info-icon-container'>
          <div className='info-icon-wrapper'>
            <AlertCircle
              width='20'
              height='20'
              fill={'#667085'}
              style={{ flexShrink: '0' }}
            />
          </div>
        </div>
        <div className='info-text-wrapper'>
          <div className='info-title-text'>{translate(`${infoTitle}`)}</div>
          <div className='info-points-wrapper'>
            {infoPoints?.map((point, index) => (
              <div
                className='info-point-wrapper'
                key={index}
              >
                <span className='info-point-dot' />
                <div className='info-point-text'>
                  {point?.map((segment, i) => highlightWords(segment, i))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
